module.exports = __webpack_public_path__ + "static/media/ic_checkBox_purple.6a8ed07f.svg";